import Button from '@material-ui/core/Button';
import React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';

const SearchIcon = ({ handleClick, expanded }) => {
    const ButtonWrapper = styled.div`
        visibility: ${expanded ? 'hidden' : 'visible'};
        pointer-events: ${expanded ? 'none' : 'all'};
        opacity: ${expanded ? 0 : 1};
        transition: opacity .5s cubic-bezier(.4,0,.2,1), visibility .3s;
        position: absolute;
        top: 0;
        right: 0;
        & .schnoffle-search-button {
            cursor: ${expanded ? 'none' : 'pointer'};
            display: inline-flex;
            font-size: 1em;
            justify-content: center;
            padding: ${props => props.theme.space[5]} ${
        props => props.theme.space[8]};
            order: 2;
            outline: none;
            height: 100%;
            min-height: ${props => props.theme.space[11]};
            width: ${props => props.theme.space[14]};
            min-width: inherit;
            text-align: center;
            margin: 0 0.75em 0 0;
            index: 5;
        }
    `;

    return (
        <ButtonWrapper>
            <Button
                onClick={handleClick}
                classes={{ root: 'schnoffle-search-button'}}
            >
                    <Icon
                        name='icon-search'
                        iconColor='common.white'
                        width='1.4em'
                        height='1.3em'
                    />
            </Button>
        </ButtonWrapper>
    );
};

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/components/header/SearchIcon.js